// Newsletter signups go to Klaviyo only — never to Shopify. The forms are plain
// <form> elements; this component owns submit entirely (preventDefault) so the
// browser never posts to Shopify, which would create a customer record. The
// Klaviyo client-side subscription is the only signup path.
(function () {
  const SOURCE_TO_SIGNUP_TYPE = {
    'Newsletter section': 'section',
    'Newsletter popup': 'popup',
    'Footer newsletter': 'footer',
  };

  function userCanBeTracked() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp.userCanBeTracked === 'function' && cp.userCanBeTracked());
  }

  // Analytics event stays consent-gated (the Klaviyo subscription itself is an
  // explicit opt-in action, so it is not gated).
  function pushSignupEvent(signupType) {
    if (!signupType) return;

    function push() {
      if (!userCanBeTracked()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'newsletter_signup', signup_type: signupType });
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([
        { name: 'consent-tracking-api', version: '0.1', onLoad: push },
      ]);
    } else {
      push();
    }
  }

  class KlaviyoNewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    handleSubmit(event) {
      event.preventDefault();

      const companyId = this.dataset.companyId;
      const listId = this.dataset.listId;
      const emailInput = this.form.querySelector('input[name="contact[email]"]');
      const email = emailInput && emailInput.value.trim();
      if (!companyId || !listId || !email) {
        this.showError();
        return;
      }

      const acceptsMarketing = !!this.form.querySelector(
        'input[name="contact[accepts_marketing]"]:checked'
      );

      const submitButton = this.form.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;
      this.hideError();

      const profileAttributes = { email: email };
      if (acceptsMarketing) {
        profileAttributes.properties = { 'Receive offers': ['Yes'] };
      }

      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: this.dataset.source || 'Newsletter signup',
            profile: { data: { type: 'profile', attributes: profileAttributes } },
          },
          relationships: { list: { data: { type: 'list', id: listId } } },
        },
      };

      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(body),
          mode: 'cors',
        }
      )
        .then((response) => {
          // A successful client subscription returns 202 Accepted.
          if (!response.ok) throw new Error('Klaviyo subscription failed: ' + response.status);
          this.showSuccess();
        })
        .catch(() => {
          if (submitButton) submitButton.disabled = false;
          this.showError();
        });
    }

    showSuccess() {
      // Mirror the pre-JS behaviour: the form is replaced by the success banner.
      if (this.form) this.form.style.display = 'none';
      this.hideError();

      const banner = this.querySelector('[data-newsletter-success]');
      if (banner) banner.style.display = '';

      // Popup: remember it was filled so it does not reappear.
      if (this.dataset.source === 'Newsletter popup') {
        try {
          localStorage.setItem('theme:popup-filled', 'true');
        } catch (e) {
          /* private mode */
        }
      }

      pushSignupEvent(SOURCE_TO_SIGNUP_TYPE[this.dataset.source]);
    }

    showError() {
      const banner = this.querySelector('[data-newsletter-error]');
      if (banner) banner.style.display = '';
    }

    hideError() {
      const banner = this.querySelector('[data-newsletter-error]');
      if (banner) banner.style.display = 'none';
    }
  }

  if (!customElements.get('klaviyo-newsletter-form')) {
    customElements.define('klaviyo-newsletter-form', KlaviyoNewsletterForm);
  }
})();
